function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { createLaunchDarklyContext, useCurrentAccountId, useCurrentProjectId } from '@adsk/alloy-provider';
import { getEnv, ENVS } from '@adsk/acs-sc-web-platform-api';
export var AdminLDContext = /*#__PURE__*/React.createContext(undefined);
var _createLaunchDarklyCo = createLaunchDarklyContext(AdminLDContext),
  PlangridLaunchDarklyProvider = _createLaunchDarklyCo.LaunchDarklyProvider,
  usePlangridFeatureFlag = _createLaunchDarklyCo.useFeatureFlag;
var clientSideIdByEnv = _defineProperty(_defineProperty(_defineProperty({}, ENVS.QA, '5cfe5a82648b9507525dcb0e'), ENVS.STAGING, '5d12565bd7bc9707683c5682'), ENVS.PRODUCTION, '5cfe5a817682e907558f568c');

/**
 * This HOC exposes Admin related feature flags to its consumers
 */
export var withPlangridFFs = function withPlangridFFs(WrappedComponent) {
  var env = getEnv();
  var WrappedComponentWithFFs = function WrappedComponentWithFFs(props) {
    var projectId = useCurrentProjectId();
    var accountId = useCurrentAccountId();
    return /*#__PURE__*/React.createElement(PlangridLaunchDarklyProvider, {
      apiKey: clientSideIdByEnv[env],
      projectEntitlementsUnavailable: !projectId && !accountId
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
  WrappedComponentWithFFs.propTypes = WrappedComponent.propTypes;
  return WrappedComponentWithFFs;
};
export { usePlangridFeatureFlag };
//# sourceMappingURL=PlangridLaunchDarklyProvider.js.map